import React, { useEffect, useState } from "react";
import queryString from 'query-string';
import Parser from 'html-react-parser';

// reactstrap components
import { Card, CardBody, Row, Col } from "reactstrap";

// style
import "assets/css/loading.css";

// services
import { showMessage } from "services/message.js";
import { api_GET } from "services/api_service.js";
import { formateDate } from "helpers/formats";

// components
import { logotipo } from "constants/Logotipo";

export default function CertificadoDestino({ history }) {
    const [showLoading, setshowLoading] = useState(false);

    var QRCode = require('qrcode.react');

    const [dadoscarteirinha, set_dadoscarteirinha] = useState(null);
    const loadDados = () => {
        let urls = history.location.search;
        let params = queryString.parse(urls);

        api_GET('protocolodestino/ByNumeroProtocolo/' + params.protocolo).then(result => {
            setshowLoading(false);
            if (result.status !== 200)
                showMessage("Aviso", result.message, 'error', null);
            else {
                if (["Cancelado", "Pendente", "Inativo"].includes(result.data.status)) {
                    if (result.data.status == "Inativo") {
                        showMessage("Aviso", "Cadastro Inativo no Sistema.", 'error', null);
                        return;
                    } else {
                        showMessage("Aviso", "Carteirinha não disponível", 'error', null);
                        return;
                    }
                }

                let protocolo = result.data;

                let local = protocolo.protocoloDestino[0].protocoloDestinoLocais.filter(f => f.protocoloDestinoLocal_Id == params.local)[0];

                let _carteirinha = {
                    cabecalho: protocolo.setupSolicitacaoAcaoNovoCadastro.setupSolicitacao.cabecalhoCertificado,
                    codCadastro: protocolo.codigoCadastro,
                    validade: protocolo.dataFimVigencia,
                    documento: protocolo.cpf_Cnpj,
                    nome: local.identificacao,
                    endereco: local.logradouro + ", " + local.numEndereco + ", " + local.bairro,
                    protocolo: params.protocolo,
                    localId: local.protocoloDestinoLocal_Id
                }

                if (protocolo.setupSolicitacaoAcaoNovoCadastro.setupSolicitacao.categoria.descricao == "Destino Final de RCC") {
                    _carteirinha.endereco = protocolo.protocoloDestino[0].logradouro + ", " +
                        protocolo.protocoloDestino[0].numEndereco + ", " +
                        protocolo.protocoloDestino[0].bairro;
                    _carteirinha.nome = protocolo.protocoloDestino[0].razaoSocial;
                }

                if (protocolo.setupSolicitacaoAcaoNovoCadastro.setupSolicitacao.categoria.descricao == "Banco de Manejo - Até 1.000m³") {
                    _carteirinha.nome = protocolo.protocoloDestino[0].razaoSocial;
                }

                set_dadoscarteirinha(_carteirinha);
            }
        })
    }

    useEffect(() => {
        loadDados();
    }, []);

    return (
        <>
            {showLoading &&
                <div className="carregandoCmp">
                    <div className="box">
                        <img src={require("assets/img/loading.gif")}></img>
                    </div>
                </div>
            }
            {dadoscarteirinha != null &&
                <div className="d-flex justify-content-center align-items-center" style={{height: "100vh"}}>
                    <Card style={{ width: "18cm", border: "1px solid blacknpm" }}>
                        <CardBody>
                            <div style={{ border: "1px solid black", padding: "0.5cm" }}>
                                <Row style={{ marginTop: "0.5cm" }}>
                                    <Col md="2" className="mt-2">
                                        <img src={logotipo()} width="150"></img>
                                    </Col>
                                    <Col md="10">
                                        {Parser(dadoscarteirinha.cabecalho)}
                                    </Col>
                                    <Col md="2">
                                    </Col>
                                    <Col md="12" className="text-center mt-4 mb-4">
                                        <b>ÁREA DE DESTINAÇÃO DOS RESÍDUOS DA CONSTRUÇÃO CIVIL</b>
                                    </Col>
                                    <Col md="6">
                                        <b>Código Cadastro - {localStorage.getItem("roc-identificacao")}: </b> {dadoscarteirinha.codCadastro}
                                    </Col>
                                    <Col md="6" className="text-right">
                                        <b>Validade: </b> {formateDate(dadoscarteirinha.validade)}
                                    </Col>
                                    <Col md="12" className="mt-4">
                                        <b>{dadoscarteirinha.documento.length > 11 ? "CNPJ" : "CPF"}: </b> {dadoscarteirinha.documento}
                                    </Col>
                                    <Col md="12">
                                        <b>{dadoscarteirinha.documento.length > 11 ? "Razão Social" : "Nome"}: </b> {dadoscarteirinha.nome}
                                    </Col>
                                    <Col md="12">
                                        <b>Endereço: </b> {dadoscarteirinha.endereco}
                                    </Col>
                                </Row>
                                <Row style={{ marginTop: "2cm", marginBottom: "2cm" }}>
                                    <Col md="12" className="text-center">
                                        <QRCode value={localStorage.getItem("roc-URL_WEB") + "/empty/certificadodestino?protocolo=" + dadoscarteirinha.protocolo + "&local=" + dadoscarteirinha.localId} />
                                    </Col>
                                </Row>
                            </div>
                        </CardBody>
                    </Card>
                </div>
            }
        </>
    );
}